import {UIGeneralServicesController} from '../../shared/scripts/UIGeneralServicesController.ts'
import {UINotificationActionController} from '../../shared/scripts/notifications/UINotificationActionController.ts'
import {UIWOnlineFriendController} from './ui_friends/UIWOnlineFriendController.ts'
import {type UIWHeaderController} from './ui_html/header/UIWHeaderController.ts'
import {type UIManager} from './ui_html/UIManager.ts'

export class UIWGeneralServicesController extends UIGeneralServicesController {
    constructor(uiManager: UIManager | undefined, uiHeaderController: UIWHeaderController | undefined) {
        super()
        this.onlineFriendController = new UIWOnlineFriendController(uiManager?.room, uiHeaderController?.notificationPanelController)

        if(!uiHeaderController?.notificationPanelController) return
        this.notificationActionController = new UINotificationActionController(uiHeaderController.notificationPanelController)
    }

    init() {
        this.onlineFriendController?.init()
    }
}
